import React, { Component } from 'react'
import axios from 'axios'

import { Container, Divider, Header, Segment, Table, Message } from 'semantic-ui-react'
import { Route, Switch, Redirect, useHistory, Link, Router, BrowserRouter } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";

// 404
import NotFound from "./404";

// marketing
import Nbd from "./pages/article/mkt/Nbd";
import Gamma from "./pages/article/mkt/Gamma";
import Dirichlet from "./pages/article/mkt/Dirichlet";

// OpenCV
import CV2Face from "./pages/article/library/opencv/Face";

// Component
import UFileUpload from "./components/util/UFileUpload";

interface ImainProps {
}

interface IMainState {
}

class Main extends React.Component<ImainProps, IMainState> {

  constructor(props: ImainProps) {
    super(props);

    this.state = {
    }

  }

  httpChangeHandler = (m: number, P0: number) => {
    axios.get('https://app.wayama.io/api/v1/test', {
    })
      .then(res => {
      })
      .catch(error => {
      })
  }

  render() {
    return (
      <Container text style={{ marginTop: '1.5rem', marginBottom: '0.2rem' }}>
        <BrowserRouter>
          <Switch>
            <Route exact path='/' component={Home} />
            {/*<Route path='/ml' component={ML} />*/}
            {/*<Route path='/qc' component={QC} />*/}
            <Route path='/article/mkt/nbd' component={Nbd} />
            <Route path='/article/mkt/gamma' component={Gamma} />
            <Route path='/article/mkt/dirichlet' component={Dirichlet} />
            <Route path='/about' component={About} />

            <Route path='/file' component={UFileUpload} />
            <Route path='/face' component={CV2Face} />
            <Route component={NotFound} />
          </Switch>
        </BrowserRouter>
      </Container>
    );
  }
}

export default Main;
